import React, { useState } from "react";
import { Link } from "react-router-dom";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { TotalBalancetype } from "../../../../redux/reports/reportsType";
import { Iicon, broadCloseIcon, broadOpenIcon } from "../../../../assets/images";
import { currencySignAndNegativeValueAdjust } from "../../../../utils/commonFunctions";
import { getData } from "../../Grouping/common";

type AppProps = {
  singleData: any;
  tableHeaders: TableHeadersType[];
  totalBalances: TotalBalancetype;
  client_code?: any;
  company_name?: any;
  start_date: string;
  end_date: string;
  isLedgerStatementPresent?: boolean;
  currencySign: string | undefined;
  count: number;
  index?: number;
  type?: string;
  recuIndex?: number;
  handleCustomerSuplierDetailsData: (invoiceType: number) => void;
};

const DetailedTrialBalaceTableData = ({
  singleData,
  totalBalances,
  tableHeaders,
  client_code,
  company_name,
  start_date,
  end_date,
  isLedgerStatementPresent,
  currencySign,
  count,
  index,
  recuIndex,
  type,
  handleCustomerSuplierDetailsData,
}: AppProps) => {
  const finalRedirectLink = {
    pathname: `/reports/${client_code}/ledger-statement?client_code=${client_code}&company_name=${company_name}`,
  };

  const handleSetLocalStorageData = (ledgerId: number) => {
    localStorage.setItem("ledger_id", ledgerId.toString());
    localStorage.setItem("start_date", start_date);
    localStorage.setItem("end_date", end_date);
  };

  const [isOpen, setIsOpen] = useState<boolean>(false);

  if (singleData?.data?.length > 0) {
    return (
      <>
        <tr>
          {tableHeaders?.length &&
            tableHeaders.map((header: TableHeadersType) => {
              if (header?.value === "ledger_name") {
                return (
                  <td
                    className="text-start"
                    style={{
                      paddingLeft: type == "recurring" ? `${3.9 * count}rem` : "",
                    }}
                    onClick={() => setIsOpen(!isOpen)}
                  >
                    <span
                      style={{
                        textDecoration: "none",
                        cursor: "pointer",
                      }}
                    >
                      <span style={{ marginLeft: "-32px", fontWeight: "700" }}>
                        <span
                          style={{
                            display: "inline-block",
                            marginRight: "2px",
                          }}
                        >
                          {isOpen ? (
                            <img
                              width="30px"
                              style={{ cursor: "pointer" }}
                              src={broadOpenIcon}
                              className="accordion-arrow"
                              alt="open"
                            />
                          ) : (
                            <img
                              width="30px"
                              style={{ cursor: "pointer" }}
                              src={broadCloseIcon}
                              className="accordion-arrow"
                              alt="close"
                            />
                          )}
                        </span>
                        {count == 1 && `${index}.`} {singleData?.ledger_name}
                      </span>
                    </span>
                    {singleData?.ledger_type_id === 2 ? (
                      <img
                        className="ml-2 pointer "
                        src={Iicon}
                        onClick={() => handleCustomerSuplierDetailsData?.(singleData?.ledger_id)}
                        alt="eye"
                      />
                    ) : (
                      ""
                    )}
                  </td>
                );
              } else if (header?.value === "opening_balance") {
                return (
                  <td className="text-start">
                    {!isOpen ? (
                      <p>
                        {currencySignAndNegativeValueAdjust(
                          currencySign,
                          singleData?.opening_balance ? singleData?.opening_balance?.toString() : "0"
                        )}
                      </p>
                    ) : (
                      ""
                    )}
                  </td>
                );
              } else if (header?.value === "total_debit_amount") {
                return (
                  <td className="text-start text-success">
                    {!isOpen ? (
                      <p>
                        {currencySignAndNegativeValueAdjust(
                          currencySign,
                          singleData?.total_debit_amount ? singleData?.total_debit_amount?.toString() : "0"
                        )}
                      </p>
                    ) : (
                      ""
                    )}
                  </td>
                );
              } else if (header?.value === "total_credit_amount") {
                return (
                  <td className="text-start text-danger">
                    {!isOpen ? (
                      <p>
                        {currencySignAndNegativeValueAdjust(
                          currencySign,
                          singleData?.total_credit_amount ? singleData?.total_credit_amount?.toString() : "0"
                        )}
                      </p>
                    ) : (
                      ""
                    )}
                  </td>
                );
              } else if (header?.value === "closing_balance") {
                return (
                  <td className="text-start">
                    {!isOpen ? (
                      <p>
                        {currencySignAndNegativeValueAdjust(
                          currencySign,
                          singleData?.closing_amount ? singleData?.closing_amount?.toString() : "0"
                        )}
                      </p>
                    ) : (
                      ""
                    )}
                  </td>
                );
              }
            })}
        </tr>
        {isOpen && (
          <>
            {getData(singleData?.data)?.map((item: any, recuIndex: number) => (
              <DetailedTrialBalaceTableData
                tableHeaders={tableHeaders}
                singleData={item}
                totalBalances={totalBalances}
                client_code={client_code}
                company_name={company_name}
                start_date={start_date}
                end_date={end_date}
                isLedgerStatementPresent={isLedgerStatementPresent}
                handleCustomerSuplierDetailsData={handleCustomerSuplierDetailsData}
                currencySign={currencySign}
                count={count + 1}
                recuIndex={recuIndex}
                index={index}
                type="recurring"
              />
            ))}
          </>
        )}
      </>
    );
  } else {
    return (
      <tr>
        {tableHeaders?.length &&
          tableHeaders.map((header: TableHeadersType) => {
            if (header?.value === "ledger_name") {
              return (
                <td
                  style={{
                    paddingLeft: type == "recurring" ? `${3.9 * count}rem` : "",
                  }}
                >
                  {isLedgerStatementPresent ? (
                    <Link
                      target="_blank"
                      to={finalRedirectLink}
                      onClick={() => handleSetLocalStorageData(singleData?.ledger_id)}
                      style={{
                        textDecoration: "underLine",
                        cursor: "pointer",
                        color: "#dd4433",
                      }}
                    >
                      {!singleData?.parent_id ? `${index}.` : ""}
                      {singleData?.ledger_name}
                    </Link>
                  ) : (
                    singleData?.ledger_name
                  )}
                  {singleData?.ledger_type_id === 2 ? (
                    <img
                      className="ml-2 pointer "
                      src={Iicon}
                      onClick={() => handleCustomerSuplierDetailsData?.(singleData?.ledger_id)}
                      alt="eye"
                    />
                  ) : (
                    ""
                  )}
                </td>
              );
            } else if (header?.value === "opening_balance") {
              return (
                <td className="text-start">
                  {currencySignAndNegativeValueAdjust(
                    currencySign,
                    singleData?.opening_balance ? singleData?.opening_balance?.toString() : "0"
                  )}
                </td>
              );
            } else if (header?.value === "total_debit_amount") {
              return (
                <td className="text-start text-success">
                  {currencySignAndNegativeValueAdjust(
                    currencySign,
                    singleData?.total_debit_amount ? singleData?.total_debit_amount?.toString() : "0"
                  )}
                </td>
              );
            } else if (header?.value === "total_credit_amount") {
              return (
                <td className="text-start text-danger">
                  {currencySignAndNegativeValueAdjust(
                    currencySign,
                    singleData?.total_credit_amount ? singleData?.total_credit_amount?.toString() : "0"
                  )}
                </td>
              );
            } else if (header?.value === "closing_balance") {
              return (
                <td className="text-start">
                  {currencySignAndNegativeValueAdjust(
                    currencySign,
                    singleData?.closing_amount ? singleData?.closing_amount?.toString() : "0"
                  )}
                </td>
              );
            }
          })}
      </tr>
    );
  }
};

export default DetailedTrialBalaceTableData;
